import { render } from "./CardStatusImplantacao.vue?vue&type=template&id=97757c94&scoped=true&ts=true"
import script from "./CardStatusImplantacao.vue?vue&type=script&lang=ts"
export * from "./CardStatusImplantacao.vue?vue&type=script&lang=ts"

import "./CardStatusImplantacao.vue?vue&type=style&index=0&id=97757c94&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97757c94"]])

export default __exports__